// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"610":"062c0619","995":"7656119c"}[chunkId] + ".chunk.css";
};